/**
 * @file: VehicleFuelType.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum VehicleFuelType {
  Gasoline = 'gasoline',
  Diesel = 'diesel',
  Natgas = 'ng',
  Electric = 'ev',
  PluginHybridElectric = 'phev',
  HybridElectric = 'hev',
  FuelCell = 'fcev',
  Methanol = 'methanol',
}

export const VehicleFuelTypeValueSet = new Set([
  VehicleFuelType.Gasoline,
  VehicleFuelType.Diesel,
  VehicleFuelType.Natgas,
  VehicleFuelType.Electric,
  VehicleFuelType.PluginHybridElectric,
  VehicleFuelType.HybridElectric,
  VehicleFuelType.FuelCell,
  VehicleFuelType.Methanol,
]);
